import Sheet from 'components/sheet';

interface WrapperMobileProps {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Wrapper for mobile Subscription confirmation information
 */
const WrapperMobile: React.FC<WrapperMobileProps> = ({ children, isOpen, onClose }) => {
  return (
    <Sheet isOpen={isOpen} onClose={onClose}>
      {children}
    </Sheet>
  );
};

export default WrapperMobile;
